import { useMemo } from 'react';
import { MerklDappCampaignsEntity } from '../other/useMerklDappCampaigns';

export const useCampaignsWithTokenImage = (
  campaignsInfo: MerklDappCampaignsEntity | undefined,
  tokenImagesMap: Record<string, string>
) => {
  return useMemo(() => {
    if (!campaignsInfo?.merkl_campaigns) return [];
    return campaignsInfo.merkl_campaigns.map((campaign) => ({
      ...campaign,
      token_0_image: tokenImagesMap[campaign.token_0_name] || '',
      token_1_image: tokenImagesMap[campaign.token_1_name] || '',
    }));
  }, [campaignsInfo, tokenImagesMap]);
};
